<template>
      <form @submit.prevent="!enquiry.uuid ? submitFn() : editSubmitFn()">
        <div class="mb-10">
          <label for="" class="text-main text-opacity-80 text-sm block mb-4 bg-white">Property For</label>
          <div class="flex">
            <span class="radio-selection">
              <input type="radio" v-model="enquiry.transaction_type_id" name="propertyFor" value="Sale" id="Sale" class="hidden">
              <label for="Sale" class="bg-gray-100 py-3 px-6 text-main rounded-xl  pills mr-3"> Sale </label>
            </span>
             <span class="radio-selection">
              <input type="radio" v-model="enquiry.transaction_type_id" name="propertyFor" value="Rental" id="Rental" class="hidden">
              <label for="Rental" class="bg-gray-100 py-3 px-6 text-main rounded-xl  pills"> {{ leadKeysList.custom_label_property_for ? 'Resale' : 'Rental' }} </label>
            </span>
          </div>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Building Type</label>
          <select v-model="enquiry.building_type" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
            <option selected disabled>Select the type</option>
            <option
              v-for="(bt, key) in propertyKeysList.building_types"
              :key="key"
              :value="bt"
            >{{bt}}</option>
          </select>
        </div>
         <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Property Type</label>
          <select v-model="enquiry.property_type" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
            <option selected disabled>Select Property Type</option>
            <option
              v-for="(pt, key) in propertyType"
              :key="key"
              :value="pt"
            >{{pt}}</option>
          </select>
        </div>
        <div class="mb-6 relative" v-if="lead_allowed_fields && lead_allowed_fields.includes('preferred_project_id')">
          <label for=""
            class="text-main text-opacity-80 text-sm block mb-2 bg-white z-10">Prefered Project</label>
              <multiselect v-model="enquiry.preferred_project_id" :searchable="true"  placeholder="Select Prefered Project" label="text" valueProp="id" :options="propertyKeysList.projects" mode="single" :taggable="true" class="multiselect-outer-wrapper"></multiselect>
        </div>
        <div class="mb-6 relative" v-if="lead_allowed_fields && lead_allowed_fields.includes('preferred_property_id')">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Prefered Property</label>
          <select v-model="enquiry.preferred_property_id" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
            <option selected disabled>Select Property Type</option>
            <option
              v-for="(pr, key) in propertyList"
              :key="key"
              :value="pr.id"
            >{{pr.name}}</option>
          </select>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Configuration</label>
          <select v-model="enquiry.configuration" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
            <option selected disabled>Select Configuration</option>
           <option
              v-for="(c, key) in leadKeysList.configuration"
              :key="key"
              :value="c"
            >{{c}}</option>
          </select>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Require Area</label>
          <input 
            type="text" 
            v-model.number="enquiry.required_area" 
            placeholder="Enter Area in selected Area Unit" 
            class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Area Unit *</label>
          <select v-model="enquiry.area_unit" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select</option>
            <option
              v-for="(a, key) in leadKeysList.area_units"
              :key="key"
              :value="a"
            >{{a}}</option>
          </select>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Name</label>
          <input type="text" v-model="enquiry.name" placeholder="Name" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Email</label>
          <input type="email" v-model="enquiry.email" placeholder="Email" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Mobile</label>
          <input type="text" v-model="enquiry.mobile" placeholder="Mobile No" inputmode="numeric" @input="enquiry.mobile = enquiry.mobile.replace(/(?!^\+)\D/g, '')" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
        </div>
         <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Possession by</label>
          <select v-model="enquiry.possession_by" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select Possession By</option>
           <option
              v-for="(p, key) in leadKeysList.possession_by"
              :key="key"
              :value="p"
            >{{p}}</option>
          </select>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Possession Status</label>
          <select v-model="enquiry.possession_status" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select</option>
            <option
              v-for="(c, key) in propertyKeysList.posesstion_status"
              :key="key"
              :value="c"
            >{{c}}</option>
          </select>
        </div>
         <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Expected Price</label>
          <input type="text" v-model="enquiry.budget" placeholder="Enter in lacs" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
        </div>
        <div class="mb-6 relative">
         <label for=""
            class="text-main text-opacity-80 text-sm block mb-2 bg-white z-10">City</label>
           <multiselect v-model="enquiry.city_id" :searchable="true"  placeholder="Select City" label="name" valueProp="id" :options="leadKeysList.cities" mode="single" :taggable="true" class="multiselect-outer-wrapper"></multiselect>
        </div>
        <div class="mb-6 relative">
          <label for=""
            class="text-main text-opacity-80 text-sm block mb-2 bg-white z-10">Localities</label>
              <multiselect v-model="enquiry.locality_ids" :searchable="true"  placeholder="Select Localities" label="name" valueProp="id" :options="Localities" mode="tags" :taggable="true" class="multiselect-outer-wrapper"></multiselect>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Status *</label>
          <select v-model="enquiry.status_id" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select Status</option>
            <option
              v-for="(s, key) in statusList"
              :key="key"
              :value="s.id"
            >{{s.name}}</option>
          </select>
        </div>
        <div class="mb-6 relative" v-if="meeting_executive">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Closing Executive</label>
          <select v-model="enquiry.closing_executive" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select Closing Executive</option>
           <option
              v-for="(ce, key) in leadKeysList.closing_executives"
              :key="key"
              :value="ce.id"
            >{{ce.name}}</option>
          </select>
        </div>
        <div class="mb-6 relative" v-if="plan_ids.includes(enquiry.status_id)">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Tentitive visit plan date</label>
          <input type="datetime-local" v-model="enquiry.tentative_visit_planned" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
        </div>
        <div class="mb-6 relative" v-if="deadStatusIds.includes('' + enquiry.status_id)">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Dead Reason</label>
          <select v-model="enquiry.dead_reason_id" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select Dead Reason</option>
            <option
              v-for="(s, key) in deadReasons"
              :key="key"
              :value="s.id"
            >{{s.reason}}</option>
          </select>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Land Type</label>
          <select v-model="enquiry.land_type" @change="toggleLeaseTypeField" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select Land Type</option>
            <option
              v-for="(lt, key) in leadKeysList.land_types"
              :key="key"
              :value="lt"
            >{{lt}}</option>
          </select>
        </div>

        <div class="mb-6 relative" v-if="showLeaseTypeField">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Lease Type</label>
          <select 
            v-model="enquiry.lease_type" 
            class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select Lease Type</option>
            <option
              v-for="(lt, key) in leadKeysList.lease_types"
              :key="key"
              :value="lt"
            >{{lt}}</option>
          </select>
        </div>

        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Zone</label>
          <select v-model="enquiry.zone" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select Zone</option>
            <option
              v-for="(z, key) in leadKeysList.zones"
              :key="key"
              :value="z"
            >{{z}}</option>
          </select>
        </div>

        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Enquiry Type</label>
          <select v-model="enquiry.enquiry_type" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select Enquiry Type</option>
            <option
              v-for="(pf, key) in leadKeysList.enquiry_type"
              :key="key"
              :value="pf"
            >{{pf}}</option>
          </select>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Sources *</label>
          <select v-model="enquiry.source_id" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select Sources</option>
            <option
              v-for="(s, key) in sourceList"
              :key="key"
              :value="s.id"
            >{{s.name}}</option>
          </select>
        </div>
        <div class="mb-6 relative" v-if="cpSourceIds.includes(enquiry.source_id)">
          <label class="text-main text-opacity-80 text-sm block mb-2 bg-white">
            Channel Partner *
          </label>

          <multiselect
            v-model="enquiry.broker_id"
            :options="cpList"
            label="name"
            valueProp="id"
            mode="single"
            :searchable="true"
            placeholder="Select Channel Partner"
            class="multiselect-outer-wrapper border text-sm border-inputBorder rounded-xl w-full"
          />
        </div>

        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">NCD</label>
          <input type="datetime-local" v-model="enquiry.ncd" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Select Assigned To</label>
          <select v-model="enquiry.user_id" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select Users</option>
            <option
              v-for="(s, key) in userList"
              :key="key"
              :value="s.id"
            >{{s.name}}</option>
          </select>
        </div>
        <div class="mt-10">
					<button type="submit" :disabled="!showProceed" class="bg-primary text-base font-semibold text-white rounded-xl p-5 w-full disabled:opacity-50" >Next</button>
				</div>
      </form>
</template>
<script>
import Multiselect from '@vueform/multiselect'
import { propertyEnums } from '@/assets/scripts/enumMaps';
export default {
  components: {
    Multiselect
  },
  props: {
    enquiry: {
      type: Object,
      required: true
    },
    submitFn: {
      type: Function,
    },
    getProperty: {
      type: Function,
    },
    propertyList: {
      type: Array,
    },
    editSubmitFn: {
      type: Function,
    }
  },
  data() {
    return {
      showLeaseTypeField: false,
      enumMaps: propertyEnums
    }
  },

  methods: {
    toggleLeaseTypeField() {
      console.log("VALUE OF THIS.ENQUIRY.LAND_TYPE", this.enquiry.land_type)
      this.showLeaseTypeField = this.enquiry.land_type === 'Lease Hold';
    }
  },
  watch: {
    'enquiry.land_type': {
      handler(newVal) {
        this.toggleLeaseTypeField();
      },
      immediate: true
    },
    'enquiry.preferred_project_id':{
      handler() {
        this.getProperty?.()
      },
      immediate: true
    }
  },
  computed: {
    showProceed() {
      if (this.enquiry.status_id && this.enquiry.source_id) {
        return true
      }
    },
    // propertyKeysList(){
    //   const keys = this.$store.getters.propertyKeys;
    //   return keys
    //   // Ensure all required properties exist to prevent template errors
    //   // if (keys) {
    //   //   return {
    //   //     projects: keys.projects || [],
    //   //     posesstion_status: keys.posesstion_status || [],
    //   //     residential_property_type: keys.residential_property_type || [],
    //   //     commercial_property_type: keys.commercial_property_type || [],
    //   //     plot_property_type: keys.plot_property_type || [],
    //   //     zones: keys.zones || []
    //   //   };
    //   // }
    //   // return {
    //   //   projects: [],
    //   //   posesstion_status: [],
    //   //   residential_property_type: [],
    //   //   commercial_property_type: [],
    //   //   plot_property_type: [],
    //   //   zones: []
    //   // };
    // },
    propertyKeysList() {
      const keys = this.$store.getters.propertyKeys || {};
      const safeKeys = {};

      Object.keys(keys).forEach(k => {
        safeKeys[k] = keys[k] || [];
      });

      return safeKeys;
    },
    propertyType() {
      if (this.enquiry.building_type === 'Residential') {
        return this.propertyKeysList.residential_property_type
      } else if (this.enquiry.building_type === 'Commercial') {
        return this.propertyKeysList.commercial_property_type
      }
        else if (this.enquiry.building_type === 'Plot') {
         return this.propertyKeysList.plot_property_type
      } else {
        return []
      }
    },
    validationMsg(){
      return validationMessage(formMessages);
    },
    leadKeysList(){
      const keys = this.$store.getters.leadKeys;
      return keys
      // Ensure all required properties exist to prevent template errors
      // if (keys) {
      //   return {
      //     configuration: keys.configuration || [],
      //     area_units: keys.area_units || [],
      //     possession_by: keys.possession_by || [],
      //     cities: keys.cities || [],
      //     locality: keys.locality || [],
      //     closing_executives: keys.closing_executives || [],
      //     enquiry_type: keys.enquiry_type|| []
      //   };
      // }
      // return {
      //   configuration: [],
      //   area_units: [],
      //   possession_by: [],
      //   cities: [],
      //   locality: [],
      //   closing_executives: [],
      //   enquiry_type: []
      // };
    },
    Localities() {
      if (this.enquiry.city_id) {
        return this.leadKeysList.locality.filter(l => l.city_id == this.enquiry.city_id)
      } else {
        return []
      }
    },
    projectList(){
      return this.$store.getters.projectMaster;
    },
    userList() {
      return this.$store.getters.usersMaster;
    },
    sourceList(){
      return this.$store.getters.sourcesMaster;
    },
    statusList(){
      return this.$store.getters.statusesMaster;
    },
    deadReasons() {
      return this.$store.getters.deadReasons;
    },
    deadStatusIds() {
      return this.$store.getters.deadStatusIds;
    },
    lead_allowed_fields() {
      return this.$store.getters.lead_allowed_fields;
    },
    cpSourceIds() {
      return this.$store.getters.cpIds;
    },
    plan_ids() {
      return this.$store.getters.plan_ids;
    },
    cpList() {
      return this.$store.getters.channel_partners;
    },
    meeting_executive() {
      return this.$store.getters.meeting_executive;
    },
  }
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>